import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import "@/assets/scss/reset.scss"

import ElementUI from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
Vue.use(ElementUI)

//全局配置mock,等后台开发好后，删除这段代码
//import http from "@/api/config"
//Vue.prototype.$http = http
//import "@/mock"

import NProgress from "nprogress"
import "nprogress/nprogress.css"

import "./icons" // icon component register global

import { getToken } from "@/utils/auth" // getToken from cookie

Vue.config.productionTip = false

//权限判断函数
function hasPermission(roles, permissionRole) {
  if (roles.indexOf("admin") > 0) return true
  if (!permissionRole) return true
  return roles.some(role => permissionRole.indexOf(role) >= 0)
}

//定义路由白名单,即不需要登录就可以进入的路由
const whiteList = ["/login"]
//路由守卫,处理每一次路由跳转逻辑
router.beforeEach((to, from, next) => {
  NProgress.start()
  let token = getToken()
  if (token) {
    if (to.path === "/login") {
      next({ path: "/" })
      NProgress.done()
    } else {
      if (store.getters.roles.length === 0) {
        //页面刷新时vuex失效，代码会从这里再次运行，从而动态加载路由，并解决侧边栏菜单
        //console.log("i ammmmmmmmmmmmmmm herrrrrrrr")
        store
          .dispatch("GetUserInfo")
          .then(res => {
            const asyncRouterMap = res.data.asyncRouterMap
            //console.log(asyncRouterMap)
            //生成VueRoutes,并调用router.addRoutes()将其添加到vue
            store.dispatch("GenerateRoutes", { asyncRouterMap }).then(() => {
              //路由已经加上，页面应该显示组件了,这是动态添加的路由，静态已经在添加前的router里了
              router.addRoutes(store.getters.addrouters)
              next({ ...to, replace: true })
            })
            //console.log(store.getters.addrouters)
            //存储一些用户信息到前端sessionStorage便于使用，比如上次登录时间，上次登录ip等
            //console.log(res.data.userinfo[0])
            localStorage.setItem("user_info", JSON.stringify(res.data.userinfo[0]))
          })
          .catch(err => {
            //如果then回调函数中发生错误，这里也可以捕捉 ，再有就是GetUserInfo中的reject(err)的错误信息
            console.log(err)
            store.dispatch("FedLogOut").then(() => {
              next({ path: "/" })
            })
          })
      } else {
        if (hasPermission(store.getters.roles, to.meta.roles)) {
          // 一直都走这里的逻辑，因为一直返回true,这里是前端判断权限-
          //明天研究一下，是怎么到达404页面的
          //console.log("i ammmmmmmmmmmmmmm herrrrrrrr")
          //console.log(to)
          //console.log(to)
          next()
        } else {
          //不会到达这里
          next({ path: "/401" })
        }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.path}`)
      //NProgress.done()
    }
  }
  //store.commit("getToken")
  //let token = store.state.user.token
  // if (to.name !== "login") {
  //   next({ name: "login" })
  // } else {
  //   next()
  // }
})
router.afterEach(() => {
  NProgress.done()
})
new Vue({
  router,
  store,
  render: h => h(App)
  // created() {
  //   store.commit("addRouter", router)
  // }
}).$mount("#app")
